function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.576 73.831H25.424a6.85 6.85 0 01-6.847-6.847V46.81a6.85 6.85 0 016.847-6.848h45.152a6.85 6.85 0 016.847 6.847v20.174a6.85 6.85 0 01-6.847 6.847z",
  fill: "#5E4537"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.983 44.338h4.891v4.89h-4.89v-4.89zm9.297 6.628v4.89h-4.891v-4.89h4.89zm-24.54 6.58h4.89v4.892h-4.89v-4.891zm-4.171-1.69v-4.89h4.89v4.89h-4.89zm7.942 0v-4.89h4.891v4.89h-4.89zm3.85 1.69h4.891v4.892h-4.89v-4.891zm4.085-1.69v-4.89h4.891v4.89h-4.89zm-4.085-11.518h4.891v4.89h-4.89v-4.89zm-7.621 0h4.89v4.89h-4.89v-4.89zm-7.614 0h4.89v4.89h-4.89v-4.89zm.39 6.628v4.89h-4.89v-4.89h4.89zm-8.012-6.628h4.89v4.89h-4.89v-4.89zm4.89 18.1h-4.89v-4.891h4.89v4.89zm2.732-4.891h4.89v4.89h-4.89v-4.89zm23.898 11.91H37.89v-4.89h20.134v4.89zm3.85-7.02h-4.89v-4.89h4.89v4.89zm7.614 0h-4.89v-4.89h4.89v4.89zm0-13.208h-4.89v-4.891h4.89v4.89z",
  fill: "#CED936"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.389 16.512H35.616a8.476 8.476 0 00-8.48 8.48 8.476 8.476 0 008.48 8.478h7.556c2.738 0 4.208 3.77 4.756 3.77.555 0 1.47-3.77 4.951-3.77h7.502a8.476 8.476 0 008.48-8.479c.007-4.686-3.795-8.48-8.472-8.48z",
  fill: "#F5F1E3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48 27.53a2.543 2.543 0 100-5.087 2.543 2.543 0 000 5.086zm-8.944 0a2.543 2.543 0 100-5.087 2.543 2.543 0 000 5.086zm17.881 0a2.543 2.543 0 100-5.087 2.543 2.543 0 000 5.086z",
  fill: "#5E4537"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.752 20.103h-5.94a3.88 3.88 0 110-7.763h5.94a3.88 3.88 0 013.881 3.882 3.876 3.876 0 01-3.881 3.881z",
  fill: "#F88191"
});

var SvgAppiconChatKeyboard = function SvgAppiconChatKeyboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconChatKeyboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-chat-keyboard.3d6b7bbe.svg";
export { ForwardRef as ReactComponent };